import styled from 'styled-components'
import { themeColor } from '@/utils'
import { ThemeColor } from '@/enums'

export enum RadioCardState {
  ACTIVE = 'active-ok',
  ACTIVE_WARNING = 'active-warn',
  INACTIVE = 'inactive',
}

const CardBorderColors = {
  [RadioCardState.ACTIVE_WARNING]: themeColor(ThemeColor.warning1),
  [RadioCardState.ACTIVE]: themeColor(ThemeColor.success1),
  [RadioCardState.INACTIVE]: themeColor(ThemeColor.b30),
}

const CardBackgroundColors = {
  [RadioCardState.ACTIVE_WARNING]: themeColor(ThemeColor.warning4),
  [RadioCardState.ACTIVE]: themeColor(ThemeColor.b10),
  [RadioCardState.INACTIVE]: themeColor(ThemeColor.b10),
}

const StyledCard = styled.button<{ state: keyof typeof CardBorderColors }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-height: 88px;
  padding: 16px;
  border: 1px solid ${({ state }) => CardBorderColors[state]};
  background-color: ${({ state }) => CardBackgroundColors[state]};
  cursor: pointer;
  border-radius: 8px;
`

const FirstLineWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

const RadioLabel = styled.label`
  font-size: 17px;
`

const RadioDotBorderColors = {
  [RadioCardState.ACTIVE_WARNING]: themeColor(ThemeColor.warning1),
  [RadioCardState.ACTIVE]: themeColor(ThemeColor.success1),
  [RadioCardState.INACTIVE]: themeColor(ThemeColor.b30),
}

const RadioDotBackgroundColors = {
  [RadioCardState.ACTIVE_WARNING]: themeColor(ThemeColor.warning1),
  [RadioCardState.ACTIVE]: themeColor(ThemeColor.success1),
  [RadioCardState.INACTIVE]: themeColor(ThemeColor.b10),
}

const RadioDot = styled.div<{ state: keyof typeof RadioDotBorderColors }>`
  width: 24px;
  height: 24px;
  border: 2px solid ${({ state }) => RadioDotBorderColors[state]};
  border-radius: 50%;
  position: relative;
  display: inline-block;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 12px;
    height: 12px;
    background-color: ${({ state }) => RadioDotBackgroundColors[state]};
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }
`
interface Props {
  state: RadioCardState
  label: string
  onClick: any
  children?: React.ReactNode
}

export const RadioCard = ({ state, label, onClick, children }: Props) => {
  return (
    <StyledCard onClick={onClick} state={state}>
      <FirstLineWrapper>
        <RadioLabel>
          <input
            type="radio"
            checked={[
              RadioCardState.ACTIVE,
              RadioCardState.ACTIVE_WARNING,
            ].includes(state)}
            hidden={true}
            readOnly
          />
          {label}
        </RadioLabel>
        <RadioDot state={state} />
      </FirstLineWrapper>
      {children}
    </StyledCard>
  )
}
